import {RouteRecordRaw} from "vue-router";
import MatchEvaluation from "@/modules/match/pages/MatchEvaluation.vue";
import MatchEvaluationBefore from "@/modules/match/pages/MatchEvaluationBefore.vue";
import MatchEvaluationAfter from "@/modules/match/pages/MatchEvaluationAfter.vue";

export const routes: RouteRecordRaw[] = [
  {
    path: '/match/:id/evaluation',
    name: 'matches.evaluation',
    component: MatchEvaluation
  },
  {
    path: '/match/:id/evaluation/before',
    name: 'matches.evaluation.before',
    component: MatchEvaluationBefore,
  },
  {
    path: '/match/:id/evaluation/after',
    name: 'matches.evaluation.after',
    component: MatchEvaluationAfter,
  },
];